import Vue from 'vue'
import Vuex from 'vuex'
import lang from "./lang/index"
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    local:'en',
    lang,
    skin:1,
    topShow :false,
    leftShow :false,
  },
  mutations: {
    changeLang(state,lang) {
      state.local = lang
    },
    toggle(state,type) {
      state[type] = !state[type]
    },
    changeSkin(state,type) {
      state.skin = type
    },
  },
  actions: {

  }
})
